module.exports = __webpack_public_path__ + "img/img_main_txt02.d7fc0588.svg";